var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 17,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M11.4643,10.5555H9.5625v-9.5C9.5625,0.475,9.0844,0,8.5,0C7.9156,0,7.4375,0.475,7.4375,1.0556v9.5H5.5356 c-0.4781,0-0.7119,0.57-0.3719,0.8973l2.9644,2.945c0.2124,0.211,0.5419,0.211,0.7543,0l2.9644-2.945 C12.1763,11.1255,11.9425,10.5555,11.4643,10.5555z M0,17.9445C0,18.525,0.4781,19,1.0625,19h14.875 C16.5219,19,17,18.525,17,17.9445c0-0.5806-0.4781-1.0556-1.0625-1.0556H1.0625C0.4781,16.8889,0,17.3639,0,17.9445z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a74e4530d60f01a6021c677a3c1b5ae1.svg";
export { ForwardRef as ReactComponent };